/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_BookInputs */

const en_pricing_book = /** @type {(inputs: Pricing_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book`)
};

const pl_pricing_book = /** @type {(inputs: Pricing_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj`)
};

/**
* | output |
* | --- |
* | "Book" |
*
* @param {Pricing_BookInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_book = /** @type {((inputs?: Pricing_BookInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_BookInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_book(inputs)
	return en_pricing_book(inputs)
});